<template>
  <ul class="list-container">
    <li v-for="(member, index) in getCurrentGroupMembers" :key="index" class="group-member">
      <div class="friend-info-container">
        <div class="author-thumb profile-img">
          <router-link :to="`/s-app/profile-page/${member.user.id}`">
            <SUserAvatar :myUser="member.user" size="small" :isProfileAvatar="false" :tryModeratorBadge="true" />
          </router-link>
        </div>
        <div class="notification-event">
          <router-link :to="`/s-app/profile-page/${member.user.id}`">
            <a class="h6 notification-friend" data-cy="memberUsername">{{
            getUserName(member.user)
            }}</a>
          </router-link>
        </div>
      </div>
      <div class="invitation-status" v-if="moderatorInvites.length && moderatorInvites[0].User_id === member.sUserId">
        <p>You've asked this member <br /> to be the moderator.</p>
        <SButtonMaterial text="Cancel request" color="transparent" textColor="danger" @button="confirmCancel(member)" />

      </div>
      <div>
    <div class="moderator-container" v-if="member.sUserId === getModerator.id && member.sUserId === loggedUser.id">
      <img class="moderator-badge" src="../../../public/svg-icons/moderatorBadge.png" alt="moderator badge"/>
      <span> Moderator</span>
    </div>
    <div v-else>
      <select @change="setInviteFields(member)" v-model="inviteId" ref="mySelect">
        <option :value="inviteId">Member</option>
        <option :value="member.user.id">
          Moderator
        </option>
      </select>
    </div>
  </div>
    </li>
    <Modal buttonName="SEND REQUEST" id="modalInvite" title="Moderator request" @button="sendInvitation"
      ref="modalInvite" :isBackButton="true" backButtonName="CANCEL" @back="closeModal('modalInvite')"
      :backButtonVisible="true" :canSkip="false" :increaseSize="true" @hidden="closeModal('modalInvite')"
      data-cy="modalModeratorInvite">
      <div>
        <p>Are you sure to ask {{ inviteName }} to be the moderator of "{{ getCurrentGroup.name }}”?</p>
        <p><strong>*Once {{ inviteName }} accepts, this action can't be undone*</strong></p>
      </div>
    </Modal>
    <Modal buttonName="GOT IT " id="modalCantInvite" title="Cancel moderator request"
      @button="closeModal('modalCantInvite')" ref="modalCantInvite" :isBackButton="false" :canSkip="false"
      :increaseSize="true" @hidden="closeModal('modalCantInvite')" data-cy="modalCantInvite">
      <div>
        <p>You can't ask 2 members to be moderator at the same time.</p>
        <p><strong>Please, cancel the other request to proceed.</strong></p>
      </div>
    </Modal>
    <Modal buttonName="KEEP IT" id="modalCancelInvite" title="Cancel moderator request" @button="closeModal('modalCancelInvite')"
      ref="modalCancelInvite" :isBackButton="true" backButtonName="CANCEL REQUEST"
      @back="cancelInvitation" :backButtonVisible="true" :canSkip="false" :increaseSize="true"
      @hidden="closeModal('modalCancelInvite')" data-cy="modalCancelInvite">
      <div>
        <p>Are you sure to cancel your ask to {{ inviteName }} to be the moderator of "{{ getCurrentGroup.name }}”?
        </p>
        <p><strong>*Once {{ inviteName }} accepts, this action can't be undone*</strong></p>
      </div>
    </Modal>
  </ul>
</template>

<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import { mapGetters } from "vuex";
import Modal from '../atoms/Modal.vue';
import SButtonMaterial from '../../material-components/atoms/SButtonMaterial.vue';

export default {
  name: "GroupMembersSettingsList",
  mixins: [UserHelperVue, GroupHelperVue, ChatHelperVue],
  components: {
    SUserAvatar,
    Modal,
    SButtonMaterial
  },
  data() {
    return {
      inviteId: "Member",
      inviteName: '',
    }
  },
  computed: {
    ...mapGetters({
      moderatorInvites: "getModeratorInvitees",
    }),
  },
  methods: {
    setInviteFields(member) {
      this.inviteName = member.sUser.firstName
      this.checkInvitation();
    },
    checkInvitation() {
      if (this.moderatorInvites.length) {
        $("#modalCantInvite").modal("show");
      } else {
        $("#modalInvite").modal("show");
      }
    },
    closeModal(modalRef) {
      this.$refs[modalRef].closeModal();
      this.inviteId = "Member"
    },
    sendInvitation() {
      this.assignModerator({ groupId: this.getCurrentGroup.id, userId: this.inviteId })
      this.closeModal('modalInvite')
    },
    confirmCancel(member) {  
      this.inviteId = member.user.id
      this.inviteName = member.sUser.firstName
      $("#modalCancelInvite").modal("show")
    },
    async cancelInvitation() {
      await this.assignModeratorCancel({ groupId: this.getCurrentGroup.id, userId: this.moderatorInvites[0].User_id })
      this.closeModal('modalCancelInvite')
    }
  },
  async mounted() {
    await this.fetchModeratorInvitees(this.getCurrentGroup.id);
  }
};
</script>

<style scoped>
.moderator-badge {
  max-width: unset;
  margin-right: 5px;
}
.list-container {
  border: 1px solid #979797;
  border-radius: 4px;
  margin: 15px 0;
  padding: 0px 25px;
}

.moderator-container {
  width: 13%;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}

.invitation-status {
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: right;
}

.invitation-status button {
  margin-right: 5px;
}

.invitation-status p {
  margin-bottom: 0;
  color: green;
  margin-right: 20px;
}

.invitation-status span {
  color: red;
}

select {
  color: rgba(0, 0, 0, 0.429);
  padding: 5px;
  font-size: 1rem;
  background-color: #d8d8d857;
  font-weight: 600;
}

option {
  white-space: unset;
}

.md-button {
  margin: 0;
}

.friend-info-container {
  display: flex;
  align-items: center;
}

.author-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-member {
  background-color: white;
  border-radius: 4px;
  margin: 15px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.group-member select {
  width: unset;
}

.notification-friend {
  color: black !important;
  font-weight: bold !important;
  font-size: 16px;
}

.notification-friend span {
  color: gray;
  font-weight: 400;
}

.friend-username {
  color: gray;
}

.my-chat-button {
  cursor: pointer;
}

.chat-message {
  width: 40px;
  height: 36px;
}

.profile-img {
  height: 45px;
  width: 45px;
}

.avatar-container {
  margin-right: 10px;
  position: relative;
}
</style>
